export enum AttachmentBoxTestButtonEnum {
  ADD_OR_EDIT_NOTE_BTN = 'add-or-edit-note-btn',
  DELETE_BTN = 'delete-btn',
  TOGGLE_NOTE_BTN = 'toggle-note-btn',
}
